import { render, staticRenderFns } from "./CustomerResearch.vue?vue&type=template&id=75c570e5&"
import script from "./CustomerResearch.vue?vue&type=script&lang=js&"
export * from "./CustomerResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports